/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
import { BaseApplication } from './base/baseApplication';
import { AppNavigatorService } from '@/AppNavigator';
import { UnitTest } from './unit.test';
import { vappContainer } from './vapp.container';
import { ProductLandingPageService } from '@pages/LandingPage';
import { SignInPageService } from '@pages/SignIn';
import { ApplicationFormPageService } from '@pages/ApplicationForm';

export class VApplication extends BaseApplication {
  private static instance: VApplication;

  private constructor(options: any = {}) {
    super(options);

    this.setupBindings();

    this.initServices();
  }

  static getInstance(options: any = {}) {
    if (!this.instance) {
      this.instance = new VApplication(options);
    }
    return this.instance;
  }

  // @ts-ignore
  async start() {
    await this.initRunLevel();
    await this.unitTest();
  }

  setupBindings() {
    //------------->>>>>--------------//
    //------------->>>>>--------------//
    // this.configure(`services.SignInPageService`, {
    //   loginRestAPI: 'http://localhost:3801/auth/basic/signin',
    // });
  }

  async initRunLevel() {}

  initServices() {
    console.log(`bla bla in initServices`);
    this.service('services.SignInPageService', SignInPageService);
    this.service(
      'services.ApplicationFormPageService',
      ApplicationFormPageService
    );
  }

  async unitTest() {
    const ut = new UnitTest();
    ut.run();
  }
}

export { vappContainer };
